// libs
import { Dispatch } from 'redux';

// actions
import { ActionTypes } from './actions';

// api
import { addToCartV2 as _addToCartV2 } from 'shared/api/cart';
import { buildStoreRedirectId } from 'shared/helpers/storeUrl';

// defs
import { DEVICE_TYPE } from 'typings/cart';

interface IAddToCartPlatForm {
  productId: string;
  quantity: number;
  deviceType: DEVICE_TYPE;
  productCustomAttributes?: Record<string, string> | null | undefined;
  storeId?: string;
  store?: string;
  returnNudgeApplicable?: boolean;
  returnNudgeVisible?: boolean;
  vendorId?: string;
  vendorType?: string;
  isBuyBoxWinner?: boolean;
}

export const addToCartPlatform = ({
  productId,
  quantity = 1,
  deviceType,
  productCustomAttributes,
  store,
  storeId,
  returnNudgeApplicable,
  returnNudgeVisible,
  vendorId,
  vendorType,
  isBuyBoxWinner = true,
}: IAddToCartPlatForm) => {
  return (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.FETCH_CART_PROGRESS });
    return _addToCartV2({
      items: [{ productId, quantity, vendorId, vendorType }],
      deviceType,
      productCustomAttributes,
      store: store || buildStoreRedirectId(storeId),
      returnNudgeApplicable,
      returnNudgeVisible,
      isBuyBoxWinner,
    })
      .then((response: any) => {
        dispatch({ type: ActionTypes.FETCH_CART_SUCCESS, payload: response });
        return response;
      })
      .catch((error: any) => {
        dispatch({ type: ActionTypes.FETCH_CART_FAILED });
        return Promise.reject(error);
      });
  };
};
